import { Row } from "antd";
import { TicklersModal } from "./components/TicklersModal";
import { ImpoundBalances } from "./components/ImpoundBalances";
import { BulkCoupons } from "./components/BulkCoupons";
import { Bulk1098 } from "./components/Bulk1098";
import { usePermissions } from "../../lib/hooks/usePermissions";
import { IncidentReports } from "./components/IncidentReports";
import { ContractFess } from "./components/ContractFees";
import { ZipCodes } from "./components/ZipCodes";
import { ConversationMessagesModal } from "./components/ConversationMessagesModal";
import { PayoffPaymentsModal } from "./components/PayoffPaymentsModal";
import { ImpoundUpcNumbersModal } from "./components/ImpoundUpcNumbersModal";

export const Reports = () => {
  const { hasAccess } = usePermissions();

  return (
    <Row className="d-block px-8">
      <Row className="my-6">
        <h3 className="h h3">Reports</h3>
      </Row>
      {hasAccess("ReportGeneration", "TicklersReport") && (
        <Row className="pt-2 pb-1">
          <TicklersModal />
        </Row>
      )}
      {hasAccess("Export", "IncidentReports") && (
        <Row className="pt-2 pb-1">
          <IncidentReports />
        </Row>
      )}
      {hasAccess("Export", "Impounds") && (
        <Row className="pt-2 pb-1">
          <ImpoundBalances />
        </Row>
      )}
      {hasAccess("Export", "ContractFees") && (
        <Row className="pt-2 pb-1">
          <ContractFess />
        </Row>
      )}
      {hasAccess("Export", "CustomerZipCodeRanks") && (
        <Row className="pt-2 pb-1">
          <ZipCodes />
        </Row>
      )}
      {hasAccess("Export", "BulkTax1098") && (
        <Row className="pt-2 pb-1">
          <Bulk1098 />
        </Row>
      )}
      {hasAccess("Export", "BulkCoupons") && (
        <Row className="pt-2 pb-1">
          <BulkCoupons />
        </Row>
      )}
      {hasAccess("Export", "ConversationMessages") && (
        <Row className="pt-2 pb-1">
          <ConversationMessagesModal />
        </Row>
      )}
      {hasAccess("Export", "PayoffPayments") && (
        <Row className="pt-2 pb-1">
          <PayoffPaymentsModal />
        </Row>
      )}
      {hasAccess("Export", "ImpoundUpcNumbers") && (
        <Row className="pt-2 pb-1">
          <ImpoundUpcNumbersModal />
        </Row>
      )}
    </Row>
  );
};
